import { queryOptions } from '@tanstack/react-query';
import type { GameRoundsResponse } from '@/ui/api/connector/types';
import { getAllGameRounds } from '@/ui/api/connector/endpoints';

export const allGameRoundsQuery = (...args: Parameters<typeof getAllGameRounds>) => {
    return queryOptions<GameRoundsResponse>({
        queryKey: ['gameRounds', ...args],
        queryFn: () => getAllGameRounds(...args),
    });
};
